import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'

import Item from './Item'
import Styles from './index.scss'
import ActionsMerge from './ActionsMerge'

const renderItemSelected = (props) => {
  const itemSelected = props.dataTypeActive === 'liveData' ? props.dataLiveSelected : props.selectedData
  return itemSelected.map((data, index) => (
    <Item
      key={data.id}
      data={data}
      index={index}
      removeSelectedData={props.removeSelectedData}
    />
  ))
}

const ModalMergeData = props => (
  <Dialog
    title={'Merge Data'}
    modal={false}
    open={props.isOpen}
    onRequestClose={props.onClose}
  >
    <div>
      <div>You're about to merge the following data</div>
      <div className={Styles.tableContainer}>
        <table className={Styles.tableContent}>
          <thead>
            <tr className={Styles.rowsContent}>
              <th>Name</th>
              <th>Quantity</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {renderItemSelected(props)}
          </tbody>
        </table>
      </div>
      <div className={Styles.containerRadioBtn}>
        <div className={Styles.radioBtnItem}>
          <input className={Styles.inputRadio} type="radio" name="typeMerge" value="newData" onChange={props.setTypeMerge} checked={props.typeMerge === 'newData'} />
          <span>Create New</span>
        </div>
        <div className={Styles.radioBtnItem}>
          <input className={Styles.inputRadio} type="radio" name="typeMerge" value="existingData" onChange={props.setTypeMerge} checked={props.typeMerge === 'existingData'} />
          <span> Merge To Existing</span>
        </div>
      </div>
      <ActionsMerge
        onCancel={props.onClose}
        setInputMergeName={props.setInputMergeName}
        inputMergeName={props.inputMergeName}
        setOpenModalMerge={props.setOpenModalMerge}
        typeMerge={props.typeMerge}
        dataSelection={props.dataSelection}
        setExistingDataSelected={props.setExistingDataSelected}
        existingDataSelected={props.existingDataSelected}
        searchDataToMerge={props.searchDataToMerge}
      />
    </div>
  </Dialog>
)

ModalMergeData.defaultProps = {
  title: '',
  isOpen: false,
  onClose: () => { },
  selectedData: [],
  removeSelectedData: () => { },
  setInputMergeName: () => { },
  inputMergeName: '',
  setOpenModalMerge: () => { },
  setTypeMerge: () => { },
  typeMerge: '',
  dataSelection: {
    rows: [],
  },
  setExistingDataSelected: () => { },
  existingDataSelected: '',
  dataLiveSelected: [],
}

renderItemSelected.defaultProps = {
  selectedData: [],
  removeSelectedData: () => { },
  dataLiveSelected: [],
}

ModalMergeData.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  setInputMergeName: PropTypes.func,
  inputMergeName: PropTypes.string,
  setOpenModalMerge: PropTypes.func,
  setTypeMerge: PropTypes.func,
  typeMerge: PropTypes.string,
  dataSelection: PropTypes.shape({
    rows: PropTypes.arrayOf(PropTypes.object),
  }).isRequired,
  setExistingDataSelected: PropTypes.func,
  existingDataSelected: PropTypes.string,
  searchDataToMerge: PropTypes.func.isRequired,
}

renderItemSelected.propTypes = {
  selectedData: PropTypes.arrayOf(PropTypes.object),
  removeSelectedData: PropTypes.func,
  dataTypeActive: PropTypes.string.isRequired,
  dataLiveSelected: PropTypes.string,
}

export default ModalMergeData
